import React, {useState} from 'react';
import {Box, IconButton, Stack, styled, TextField, Typography} from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import withMainContainer from '../components/WithMainContainer.js';
import BlogPost from '../components/BlogPost.js';
import {useUser} from '../util/user.js';
import {withTitle} from '../title.js';
import SCButton from '../components/SCButton.js';
import {withPermGuard} from '../components/PermGuard.js';
import {withLoginRequire} from '../components/Login.js';

const StyledTextField = styled(props=>{
    let {className, ...rest} = props;
    return <TextField className={className}
      InputProps={{sx: {borderRadius: 0}}}
      {...rest}/>
})`
    background-color: ${p=>p.theme.palette.common.white};
`;

const StyledTextArea = styled(props=>{
    return <textarea {...props}/>
})`
    width: 100%;
    height: 100%;
    direction: rtl;
    resize: none;
    font-family: system-ui;
    border: 1px solid #ccc;
    border-radius: 0 0 8px 0;
    padding: 8px;
    background-color: ${p=>p.theme.palette.common.white};
`;

const EditorTextArea = props=>{
    let {value, onChange} = props;
    return <StyledTextArea value={value}
      onChange={ev=>onChange(ev.target.value)}/>;
};

const CONTENT_EXAMPLE = `# הנה טקסט גדול לדוגמא
והנה **טקסט בבולד**

ותמונה זה בכלל ככה:

![](https://ik.imagekit.io/nn3phmxu4z/simona_cherry/static/hands-circle.png)`;

const BlogPostWrapper = styled(Box)`
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 0 0 0 8px;
    width: 100%;
    height: 100%;
    overflow: auto;
`;

const Toolbar = styled(props=>{
    let {className} = props;
    return <Stack className={className} direction="row" justifyContent="space-between">
      <Stack direction="row">
        <IconButton sx={{borderRadius: '0 8px 0 0'}}><FormatBoldIcon/></IconButton>
        <IconButton sx={{borderRadius: 0}}><FormatItalicIcon/></IconButton>
        <IconButton sx={{borderRadius: 0}}><FormatUnderlinedIcon/></IconButton>
        <IconButton sx={{borderRadius: 0}}><StrikethroughSIcon/></IconButton>
      </Stack>
      <Stack direction="row">
        <SCButton text="שמירת טיוטה" sx={{borderRadius: 0}}/>
        <SCButton text="פרסום" sx={{borderRadius: '8px 0 0 0'}} variant="contained"/>
      </Stack>
    </Stack>
})`
    border: 1px solid #ccc;
    border-radius: 8px 8px 0 0;
    width: 100%;
`;

const PostEditor = props=>{
    let [title, setTitle] = useState('כותרת הפוסט');
    let [content, setContent] = useState(CONTENT_EXAMPLE);
    return <Stack padding={2}>
      <Toolbar/>
      <Stack direction="row" width="100%" flexWrap="nowrap"
        height="400px">
        <Stack flexGrow={1} sx={{width: '50%', maxWidth: '50%'}}
          direction="column">
          <StyledTextField value={title} onChange={ev=>setTitle(ev.target.value)}
            placeholder="כותרת הפוסט..." size="small"/>
          <EditorTextArea value={content} onChange={setContent}/>
        </Stack>
        <BlogPostWrapper flexGrow={1} sx={{width: '50%', maxWidth: '50%'}}>
          <BlogPost title={title} content={content}/>
        </BlogPostWrapper>
      </Stack>
    </Stack>;
};

const AdminBlog = ()=>{
    let [user, loadingUser] = useUser();
    return <PostEditor/>;
};

export default withTitle(`סימונה צ'רי - פאנל ניהול מאמרים`, withMainContainer(withLoginRequire(withPermGuard(AdminBlog, 'admin'))));